import { render, staticRenderFns } from "./Actividades.vue?vue&type=template&id=6f195c3e&scoped=true&"
import script from "./Actividades.vue?vue&type=script&lang=js&"
export * from "./Actividades.vue?vue&type=script&lang=js&"
import style0 from "./Actividades.vue?vue&type=style&index=0&id=6f195c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f195c3e",
  null
  
)

export default component.exports